import React from 'react';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

const SupportedBrowsersBase: React.FC = () => (
    <>
        <h1>
            Zalecane przeglądarki
        </h1>
        <h2>
            Przeglądarka Internet Explorer wkrótce przestanie być wspierana.
        </h2>
        <div>
            <p>
                {' '}
                Zachęcamy do skorzystania z nowszych przeglądarek gwarantujących wyższy poziom bezpieczeństwa oraz poprawne wyświetlanie naszego serwisu.
                Aby móc w pełni korzystać ze Skąpca, pobierz jedną z zalecanych przeglądarek:
            </p>
            <br />
            <ul>
                <li>
                    <a
                        href="https://www.microsoft.com/pl-pl/edge?utm_source=skapiec.pl&utm_medium=landing_page&utm_campaign=supported_browsers"
                        target={LinkTarget.BLANK}
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                    >
                        Microsoft Edge
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.opera.com/pl?utm_source=skapiec.pl&utm_medium=landing_page&utm_campaign=supported_browsers"
                        target={LinkTarget.BLANK}
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                    >
                        Opera
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.mozilla.org/pl/firefox?utm_source=skapiec.pl&utm_medium=landing_page&utm_campaign=supported_browsers"
                        target={LinkTarget.BLANK}
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                    >
                        Firefox
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.google.pl/intl/pl/chrome?utm_source=skapiec.pl&utm_medium=landing_page&utm_campaign=supported_browsers"
                        target={LinkTarget.BLANK}
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                    >
                        Chrome
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.apple.com/pl-pl/safari?utm_source=skapiec.pl&utm_medium=landing_page&utm_campaign=supported_browsers"
                        target={LinkTarget.BLANK}
                        rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                    >
                        Safari
                    </a>
                </li>
            </ul>
        </div>
    </>
);

export default SupportedBrowsersBase;
